<div class="source-status-container">
    <table class="wm-table">
        <colgroup>
            <col width="30" *ngIf="!showCommitedFile">
            <col width="650">
            <col width="100">
            <col>
        </colgroup>
        <thead>
            <tr>
                <th class="text-center" *ngIf="!showCommitedFile"></th>
                <th>
                    <label [ngClass]="!showCommitedFile? 'checkbox-inline file-path-string':''">
                        <input *ngIf="!showCommitedFile && selectedFileType === 'USER_CHANGES_SINCE_LAST_PULLED' || selectedFileType === 'USER_CHANGES_SINCE_LAST_PUSHED'" name="wm-check-all-files" type="checkbox"
                            (change)="addOrRemoveFiles()" [(ngModel)]="isAllFileChecked"
                            class="ng-pristine ng-untouched ng-valid ng-empty">
                         {{locale['LABEL_FILE_PATH']}}
                    </label>
                </th>
                <th> {{locale['LABEL_FILE_STATUS']}}</th>
                <th class="text-center"></th>
            </tr>
        </thead>
    </table>
    <div class="file-status-content">
        <table class="wm-table">
            <colgroup>
                <col width="30" *ngIf="!showCommitedFile">
                <col width="650">
                <col width="100">
                <col>
            </colgroup>
            <ng-container *ngIf="!showCommitedFile; else showCommitedTableBody">
                <tbody *ngFor="let file of allFileList">
                    <tr>
                        <td class="text-center">
                            <ng-container *ngIf="file.files">
                                <span *ngIf="file.files.length">
                                    <i class="wm-icon plus-minus wi" [ngClass]="!file.show  ? 'wi-plus' : 'wi-minus'"
                                        (click)="file.show=!file.show"></i>
                                </span>
                            </ng-container>
                        </td>
                        <td [title]="file.filepath">
                            <label class="checkbox-inline file-path-string">
                                <input *ngIf="selectedFileType === 'USER_CHANGES_SINCE_LAST_PULLED' || selectedFileType === 'USER_CHANGES_SINCE_LAST_PUSHED'" type="checkbox" class="file-check ng-valid ng-dirty ng-touched ng-empty"
                                    [(ngModel)]="file.isChecked" (change)="updateCheckList(file)">

                                <span class="icon">
                                    <i class="wm-icon wms {{getFileIcon(file)}}"></i>
                                </span>
                                <span *ngIf="file.files && !file.files.length || file.groupType === 'FOLDER'"> {{ file.filepath}}</span>

                                <span *ngIf="file.files && file.files.length && file.groupType !== 'FOLDER'"
                                    >
                                    <strong class=""> {{ file.name }}</strong> {{ file.vcsDiffType | titlecase
                                    }} <i class="sub text-muted">({{file.groupType | titlecase}})</i>
                                </span>
                                <span *ngIf="file.files && !file.files.length || file.pathType=== 'FILE'"
                                    > {{ file.filepath}}</span>
                            </label>

                        </td>
                        <td [ngClass]="file.vcsDiffType">
                            <span *ngIf="file.groupType !== 'FOLDER'" >{{ file.vcsDiffType
                                }}</span>
                        </td>
                        <td class="text-center">
                            <i class="wms wms-vcs-show-diff" title="Show Diff" (click)="showDiff(file)"
                                [ngClass]="{ 'ng-show': file.pathType === 'FILE', 'ng-hide': file.groupType }"></i>
                        </td>
                    </tr>
                    <tr *ngFor="let child of file.files" [hidden]="!file.show" class="sub-files ">
                        <td class="text-center"></td>
                        <td [title]="child.filepath">
                            <label class="checkbox-inline file-path-string child-checkbox-offset">
                                <input type="checkbox"
                                    class="file-check ng-valid  ng-dirty ng-valid-parse ng-empty ng-touched"
                                    [disabled]="(file.vcsDiffType === 'ADDED')||(file.vcsDiffType === 'DELETED')" [(ngModel)]="child.isChecked"
                                    (change)="updateCheckListSub(child, file)">
                                <span class="icon"><i class="wm-icon wms {{getFileIcon(child)}}"></i></span>
                                {{ child.filepath }}
                            </label>
                        </td>
                        <td class="{{ child.vcsDiffType }}">{{ child.vcsDiffType }}</td>
                        <td class="text-center">
                            <i class="wms wms-vcs-show-diff" title="Show Diff" (click)="showDiff(child)"
                                [ngClass]="{ 'ng-show': child.pathType === 'FILE' }"></i>
                        </td>
                    </tr>
                </tbody>
            </ng-container>
            <ng-template #showCommitedTableBody>
                <tbody>
                    <tr *ngFor="let file of allFileList">
                        <td [title]="file.filepath">
                            <label class="file-path-string">
                                <span class="icon">
                                     <i class="wm-icon wms {{getFileIcon(file)}}"></i>
                                </span>
                                <span> {{ file.filepath}}</span>
                            </label>
                        </td>
                        <td [ngClass]="file.vcsDiffType">
                            <span> {{ file.vcsDiffType
                                }}</span>
                        </td>
                        <td class="text-center">
                            <i class="wms wms-vcs-show-diff" title="Show Diff" (click)="showDiff(file)"
                                [ngClass]="{ 'ng-show': file.pathType === 'FILE', 'ng-hide': file.groupType }"></i>
                        </td>
                    </tr>
                </tbody>
            </ng-template>
        </table>
    </div>
</div>
